import { render } from "./RiProdcategory08.vue?vue&type=template&id=07dd34aa"
import script from "./RiProdcategory08.vue?vue&type=script&lang=js"
export * from "./RiProdcategory08.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory08.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07dd34aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07dd34aa', __exports__)) {
    api.reload('07dd34aa', __exports__)
  }
  
  module.hot.accept("./RiProdcategory08.vue?vue&type=template&id=07dd34aa", () => {
    api.rerender('07dd34aa', render)
  })

}


export default __exports__